var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allowedDomain)?_c('v-app',{style:({
    'overflow-y':
      _vm.getWebchat().interaction.state == 'started' ? 'hidden' : 'auto',
  })},[(_vm.showWelcome)?_c('welcome-message',{staticClass:"welcome-message-header"}):_vm._e(),_c('accessibility-options'),_c('router-view',{ref:"view"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }